<template>
  <div class="default-width skeleton-card"></div>
</template>

<script src="./skeleton-card.ts"></script>
<style src="./skeleton-card.scss" lang="scss"></style>
